module.exports = "/images/add-to-collection.gif?f43788455069669102d4f2758e80fa55";